import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig from 'actions/BaseAjaxConfig';
import get from 'lodash/get';

export const GET_ADDRESS_FROM_LAT_LNG_REQUEST = 'GET_ADDRESS_FROM_LAT_LNG_REQUEST';
export const GET_ADDRESS_FROM_LAT_LNG_SUCCESS = 'GET_ADDRESS_FROM_LAT_LNG_SUCCESS';
export const GET_ADDRESS_FROM_LAT_LNG_ERROR = 'GET_ADDRESS_FROM_LAT_LNG_ERROR';
export const RESET_ADDRESS_FROM_LAT_LNG_RESPONSE = 'RESET_ADDRESS_FROM_LAT_LNG_RESPONSE';

function getAddressFromLatLngRequest() {
	return { type: GET_ADDRESS_FROM_LAT_LNG_REQUEST };
}

function getAddressFromLatLngSuccess(data) {
	return { type: GET_ADDRESS_FROM_LAT_LNG_SUCCESS, data };
}

function getAddressFromLatLngError(error) {
	return { type: GET_ADDRESS_FROM_LAT_LNG_ERROR, error };
}

export function getAddressFromLatLngAction(lat, lng) {
	return dispatch => {
		dispatch(getAddressFromLatLngRequest());
		return ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/1/address/point-location',
				query: { point: `${lat},${lng}` }
			})
		)
			.then(json => {
				if (!get(json, ['RESPONSE', 'addressComponents'])) {
					return Promise.reject(json);
				}
				return dispatch(getAddressFromLatLngSuccess(json['RESPONSE']));
			})
			.catch(err => dispatch(getAddressFromLatLngError(err)));
	};
}

export function resetAddressFromLatLngAction() {
	return { type: RESET_ADDRESS_FROM_LAT_LNG_RESPONSE };
}
